import { render, staticRenderFns } from "./BankingTransac.vue?vue&type=template&id=1cc9630f&scoped=true"
import script from "./BankingTransac.vue?vue&type=script&lang=js"
export * from "./BankingTransac.vue?vue&type=script&lang=js"
import style0 from "./BankingTransac.vue?vue&type=style&index=0&id=1cc9630f&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc9630f",
  null
  
)

export default component.exports